/**
 * Created by Ella Ma on 02/14/2019.
 * Description:
 *
 * ------ maintenance history ------
 */

import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subscription, of as observableOf } from 'rxjs';
import { filter, catchError, take } from 'rxjs/operators';
import { DatePipe } from '@angular/common';
import { AppState } from '../../redux';
import { AuditTrailService } from '../../tamalelibs/services/audit-trail.service';
import { ScreenActionTypes } from '../../redux/actions/screen.actions';
import { GridLogConfig, GridLogActionType, FilterParams, GridLogEventType } from './audit-log-grid/audit-log-grid.config';
import { AuditLogFilterConfig, GridEventType, GridActionType } from './audit-log-filter/audit-log-filter.config';
import { AlertWindowService } from '../../widgets/alert-window/alert-window.service';
import { AlertButton, AlertBtnTypes } from '../../widgets/alert-window/alert-window.model';
import { GridPayload } from '../../widgets/grid/grid.config';
import { businessConstants } from '../../constants/business.constants';
import { FileHelperService } from '../../services/file-helper.service';

@Component({
    selector: 'tam-audit-log',
    templateUrl: './audit-log.component.html',
    styleUrls: ['./audit-log.component.scss']
})

export class AuditLogComponent implements OnInit, OnDestroy {

    gridConfig: GridLogConfig;
    filterConfig: AuditLogFilterConfig;
    objectTypeItems = [{
        name: 'Note',
        id: 'entry'
    }, {
        name: 'File',
        id: 'file'
    }, {
        name: 'Entity',
        id: 'entity'
    }, {
        name: 'Contact',
        id: 'contact'
    }];
    selectedObject = {
        name: 'Note',
        id: 'entry'
    };
    total = 0;
    objectType = 'entry';

    private _filterParams: FilterParams;
    private _sortParams: GridPayload;
    private _destroySubscriptions: Array<Subscription> = [];

    private _ngUnsubscribe: Subscription;

    constructor(
        private _route: ActivatedRoute,
        private _store: Store<AppState>,
        private _APIServices: AuditTrailService,
        private _alertWindow: AlertWindowService,
        private _datePipe: DatePipe,
        private _fileHelperService: FileHelperService,
    ) {
    }

    /**
     * Event handler for the event fired after the grid data is fetched, during which the status of filter button should be restored.
     * @param isLoaded a flag indicating whether the grid is loaded.
     */
    afterGridLoaded(isLoaded: boolean) {
        if (isLoaded) {
            this.filterConfig.actions$.next({ type: GridActionType.changeObjectType });
        }
    }

    ngOnInit() {
        this.gridConfig = new GridLogConfig();

        this.filterConfig = new AuditLogFilterConfig();

        const currentPageInfo: any = {
            url: this._route.snapshot.url,
            name: 'Audit Log',
            type: 'AUDIT_LOG',
            screenType: businessConstants.screenType.auditLog
        };
        this._store.dispatch({
            type: ScreenActionTypes.SET_VALUE,
            payload: currentPageInfo
        });

        this._destroySubscriptions.push(
            this.filterConfig.events$.pipe(
                filter(data => data.type === GridEventType.apply)
            ).subscribe((data) => {
                this._filterParams = data.payload;
                this.objectType = this.selectedObject.id;
                setTimeout(() => {
                    this.gridConfig.actions$.next({ type: GridLogActionType.reloadGrid, payload: data.payload });
                });
            }),
            this.gridConfig.events$.pipe(
                filter(data => data.type === GridLogEventType.totalUpdate)
            ).subscribe((data) => {
                this.total = data.payload;
            }),
            this.gridConfig.events$.pipe(
                filter(data => data.type === GridLogEventType.sortParamsToGet)
            ).subscribe((data) => {
                this._sortParams = data.payload;
            }),
            this.filterConfig.events$.pipe(
                filter(data => data.type === GridEventType.initFilterParams)
            ).subscribe((data) => {
                this._filterParams = data.payload;
                setTimeout(() => {
                    this.gridConfig.actions$.next({ type: GridLogActionType.reloadGrid, payload: this._filterParams });
                });
            }),
        );
    }

    ngOnDestroy() {
        this._destroySubscriptions.forEach(item => item.unsubscribe());
        if (this._ngUnsubscribe) {
            this._ngUnsubscribe.unsubscribe();
        }
    }

    changeObjectType() {
        if (this.selectedObject) {
            this.objectType = this.selectedObject.id;
        } else {
            this.objectType = '';
        }
        this.filterConfig.actions$.next({ type: GridActionType.changeObjectType, payload: this.objectType });
    }

    download() {
        this.showDownloadDialog();
        this._ngUnsubscribe = this._APIServices.downloadAduitList(this._sortParams, this._filterParams, this.selectedObject.id).pipe(
            take(1),
            catchError(() => {
                return observableOf();
            })).subscribe((res) => {
                this._alertWindow.close();
                this._fileHelperService.downloadFunction(res, `Audit Log ${this._datePipe.transform(Date.now(), 'MMM dd yyyy')}.xlsx`);
            });
    }

    showDownloadDialog() {
        const cancleBtn: AlertButton = {
            text: 'Cancel',
            type: AlertBtnTypes.destructive
        };

        const subscription = this._alertWindow.custom('Cancel', ['Downloading...'], cancleBtn)
            .subscribe(() => {
                this._ngUnsubscribe.unsubscribe();
                subscription.unsubscribe();
            });
    }
}

